module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_9525_mousy_grey.ae12e6b6.jpg";